export const paymentMP = {
  products: {
    nulinga: {
      success: {
        buttonRef: 'https://nulinga.com/postulantes/new?token=BX4',
      },
    },
  },
}
